import styled, { css } from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';
import {
  themeGetCss,
  disabled,
  themeGetResponsive,
  themeGetAsRem,
  forcedColorsMedia,
} from '@blueprint/ui';

import Box from '../Box';

const SelectBox = styled(Box)`
  ${themeGetCss('nativeDropdown.select')}
  appearance: none;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  &:hover,
  &:active,
  &:focus {
    background-color: ${themeGet('nativeDropdown.variants.primary.bg')};
    border-color: ${themeGet('nativeDropdown.variants.primary.border')};

    &.dark {
      background-color: transparent;
    }
  }

  &.focus-visible {
    outline: none;
  }

  &:focus::-ms-value {
    background-color: ${themeGet('nativeDropdown.variants.primary.bg')};
    color: ${themeGet('nativeDropdown.variants.primary.color')};
  }

  &.dark:focus::-ms-value {
    background-color: transparent;
    color: #fff;
  }

  &.invalid {
    background-color: ${themeGet('nativeDropdown.variants.secondary.bg')};
    border-color: ${themeGet('nativeDropdown.variants.secondary.border')};
    color: ${themeGet('nativeDropdown.variants.secondary.color')};

    &:focus,
    &:hover {
      background-color: ${themeGet('nativeDropdown.variants.secondary.bg')};
      border-color: ${themeGet('nativeDropdown.variants.secondary.border')};
    }
    _:-ms-lang(x),
    &:active {
      background-color: ${themeGet('nativeDropdown.variants.primary.bg')};
      border-color: ${themeGet('nativeDropdown.variants.secondary.border')};
    }

    &:focus::-ms-value {
      background-color: ${themeGet('nativeDropdown.variants.secondary.bg')};
      color: ${themeGet('nativeDropdown.variants.secondary.color')};
    }
  }

  &::-ms-expand {
    display: none;
  }

  &.disabled {
    ${disabled({ useProp: true })}
    cursor: not-allowed;
    opacity: 0.3;
  }

  ${({ selectTitle, vMedia }) =>
    !selectTitle &&
    themeGetResponsive({
      vMedia,
      vMediaStyles: css`
        ${themeGetAsRem('nativeDropdown.select.small')};
      `,
    })}

  ${forcedColorsMedia()`
    &:disabled {
      opacity: 1;
    }
  `}
`;

export default SelectBox;
